import { 
    GET_PRODUCT_INFO, 
    FETCH_PRODUCT_COVERAGE,
    OPEN_COVERAGE_ACCORDION, 
    OPEN_MODAL_QUOTATION_DATE_WARNING, CLOSE_MODAL_QUOTATION_DATE_WARNING, 
    SET_USER_DETAILS,
    GET_INFOS_PROSPECT,
    OPEN_MODAL_QUOTATION_DATE_YEAR,
    CLOSE_MODAL_QUOTATION_DATE_YEAR, 
} from '../actions/actionTypes';
import { groupByCategory, toggleAccordion } from '../utils'

const coverage = (state = {}, action) => {
    switch (action.type) {
        case GET_PRODUCT_INFO:
            return ({
                ...state, productInfo: action.productInfo
            });
        case FETCH_PRODUCT_COVERAGE:
            return ({
                ...state,
                productCoverage: {
                    ...action.productCoverage,
                    benefits: groupByCategory(action.productCoverage.benefits)
                },
                rawProductCoverage: action.productCoverage.benefits
            });
        case OPEN_COVERAGE_ACCORDION:
            return ({
                ...state,
                productCoverage: {
                    ...state.productCoverage,
                    benefits: toggleAccordion(state.productCoverage.benefits, action.code)
                }
            })
        case OPEN_MODAL_QUOTATION_DATE_WARNING:
            return {
                ...state,
                isModalQuotationDateWarningActive: true,
            }
        case CLOSE_MODAL_QUOTATION_DATE_WARNING:
            return {
                ...state,
                isModalQuotationDateWarningActive: false,
            }
        case SET_USER_DETAILS:
            return {
                ...state,
                userDetails: action.userDetails
            }
        case GET_INFOS_PROSPECT:
            if(action.infos){
                return {
                    ...state,
                    prospect: action.infos
                }
            }
            return state
        case OPEN_MODAL_QUOTATION_DATE_YEAR:
            return {
                ...state,
                isModalQuotationDateYearActive: true,
            }
        case CLOSE_MODAL_QUOTATION_DATE_YEAR:
            return {
                ...state,
                isModalQuotationDateYearActive: false,
            }
        default:
            return state;
    }
};

export default coverage;



// WEBPACK FOOTER //
// ./src/reducers/coverageReducer.js